/**
 * Location and timezone utilities for astrological calculations
 */

// Common cities database for quick lookup
const CITY_DATABASE = {
  'New York, NY': { lat: 40.7128, lon: -74.0060, tz: 'America/New_York' },
  'New York': { lat: 40.7128, lon: -74.0060, tz: 'America/New_York' },
  'Los Angeles, CA': { lat: 34.0522, lon: -118.2437, tz: 'America/Los_Angeles' },
  'Los Angeles': { lat: 34.0522, lon: -118.2437, tz: 'America/Los_Angeles' },
  'Chicago, IL': { lat: 41.8781, lon: -87.6298, tz: 'America/Chicago' },
  'Chicago': { lat: 41.8781, lon: -87.6298, tz: 'America/Chicago' },
  'London': { lat: 51.5074, lon: -0.1278, tz: 'Europe/London' },
  'London, UK': { lat: 51.5074, lon: -0.1278, tz: 'Europe/London' },
  'Paris': { lat: 48.8566, lon: 2.3522, tz: 'Europe/Paris' },
  'Paris, France': { lat: 48.8566, lon: 2.3522, tz: 'Europe/Paris' },
  'Tokyo': { lat: 35.6762, lon: 139.6503, tz: 'Asia/Tokyo' },
  'Tokyo, Japan': { lat: 35.6762, lon: 139.6503, tz: 'Asia/Tokyo' },
  'Sydney': { lat: -33.8688, lon: 151.2093, tz: 'Australia/Sydney' },
  'Sydney, Australia': { lat: -33.8688, lon: 151.2093, tz: 'Australia/Sydney' },
  'Mumbai': { lat: 19.0760, lon: 72.8777, tz: 'Asia/Kolkata' },
  'Mumbai, India': { lat: 19.0760, lon: 72.8777, tz: 'Asia/Kolkata' },
  'Dubai': { lat: 25.2048, lon: 55.2708, tz: 'Asia/Dubai' },
  'Dubai, UAE': { lat: 25.2048, lon: 55.2708, tz: 'Asia/Dubai' },
  'Toronto': { lat: 43.6532, lon: -79.3832, tz: 'America/Toronto' },
  'Toronto, Canada': { lat: 43.6532, lon: -79.3832, tz: 'America/Toronto' },
  'Berlin': { lat: 52.5200, lon: 13.4050, tz: 'Europe/Berlin' },
  'Berlin, Germany': { lat: 52.5200, lon: 13.4050, tz: 'Europe/Berlin' },
  'Moscow': { lat: 55.7558, lon: 37.6173, tz: 'Europe/Moscow' },
  'Moscow, Russia': { lat: 55.7558, lon: 37.6173, tz: 'Europe/Moscow' },
  'Singapore': { lat: 1.3521, lon: 103.8198, tz: 'Asia/Singapore' },
  'Hong Kong': { lat: 22.3193, lon: 114.1694, tz: 'Asia/Hong_Kong' },
  'San Francisco, CA': { lat: 37.7749, lon: -122.4194, tz: 'America/Los_Angeles' },
  'San Francisco': { lat: 37.7749, lon: -122.4194, tz: 'America/Los_Angeles' },
  'Miami, FL': { lat: 25.7617, lon: -80.1918, tz: 'America/New_York' },
  'Miami': { lat: 25.7617, lon: -80.1918, tz: 'America/New_York' },
  'Seattle, WA': { lat: 47.6062, lon: -122.3321, tz: 'America/Los_Angeles' },
  'Seattle': { lat: 47.6062, lon: -122.3321, tz: 'America/Los_Angeles' },
  'Boston, MA': { lat: 42.3601, lon: -71.0589, tz: 'America/New_York' },
  'Boston': { lat: 42.3601, lon: -71.0589, tz: 'America/New_York' },
  'Rome': { lat: 41.9028, lon: 12.4964, tz: 'Europe/Rome' },
  'Rome, Italy': { lat: 41.9028, lon: 12.4964, tz: 'Europe/Rome' },
  'Madrid': { lat: 40.4168, lon: -3.7038, tz: 'Europe/Madrid' },
  'Madrid, Spain': { lat: 40.4168, lon: -3.7038, tz: 'Europe/Madrid' },
  'Amsterdam': { lat: 52.3676, lon: 4.9041, tz: 'Europe/Amsterdam' },
  'Amsterdam, Netherlands': { lat: 52.3676, lon: 4.9041, tz: 'Europe/Amsterdam' },
  'Athens': { lat: 37.9838, lon: 23.7275, tz: 'Europe/Athens' },
  'Athens, Greece': { lat: 37.9838, lon: 23.7275, tz: 'Europe/Athens' },
  'Istanbul': { lat: 41.0082, lon: 28.9784, tz: 'Europe/Istanbul' },
  'Istanbul, Turkey': { lat: 41.0082, lon: 28.9784, tz: 'Europe/Istanbul' },
  'Bangkok': { lat: 13.7563, lon: 100.5018, tz: 'Asia/Bangkok' },
  'Bangkok, Thailand': { lat: 13.7563, lon: 100.5018, tz: 'Asia/Bangkok' },
  'Beijing': { lat: 39.9042, lon: 116.4074, tz: 'Asia/Shanghai' },
  'Beijing, China': { lat: 39.9042, lon: 116.4074, tz: 'Asia/Shanghai' },
  'Shanghai': { lat: 31.2304, lon: 121.4737, tz: 'Asia/Shanghai' },
  'Shanghai, China': { lat: 31.2304, lon: 121.4737, tz: 'Asia/Shanghai' },
  'Seoul': { lat: 37.5665, lon: 126.9780, tz: 'Asia/Seoul' },
  'Seoul, South Korea': { lat: 37.5665, lon: 126.9780, tz: 'Asia/Seoul' },
  'Mexico City': { lat: 19.4326, lon: -99.1332, tz: 'America/Mexico_City' },
  'Mexico City, Mexico': { lat: 19.4326, lon: -99.1332, tz: 'America/Mexico_City' },
  'Rio de Janeiro': { lat: -22.9068, lon: -43.1729, tz: 'America/Sao_Paulo' },
  'Rio de Janeiro, Brazil': { lat: -22.9068, lon: -43.1729, tz: 'America/Sao_Paulo' },
  'Buenos Aires': { lat: -34.6037, lon: -58.3816, tz: 'America/Argentina/Buenos_Aires' },
  'Buenos Aires, Argentina': { lat: -34.6037, lon: -58.3816, tz: 'America/Argentina/Buenos_Aires' },
  'Cairo': { lat: 30.0444, lon: 31.2357, tz: 'Africa/Cairo' },
  'Cairo, Egypt': { lat: 30.0444, lon: 31.2357, tz: 'Africa/Cairo' },
  'Cape Town': { lat: -33.9249, lon: 18.4241, tz: 'Africa/Johannesburg' },
  'Cape Town, South Africa': { lat: -33.9249, lon: 18.4241, tz: 'Africa/Johannesburg' },

  // Romania - All county capitals + cities/towns
  'Bucharest': { lat: 44.4268, lon: 26.1025, tz: 'Europe/Bucharest' },
  'Bucharest, Romania': { lat: 44.4268, lon: 26.1025, tz: 'Europe/Bucharest' },
  'București': { lat: 44.4268, lon: 26.1025, tz: 'Europe/Bucharest' },
  'Cluj-Napoca': { lat: 46.7712, lon: 23.6236, tz: 'Europe/Bucharest' },
  'Cluj-Napoca, Romania': { lat: 46.7712, lon: 23.6236, tz: 'Europe/Bucharest' },
  'Cluj': { lat: 46.7712, lon: 23.6236, tz: 'Europe/Bucharest' },
  'Timișoara': { lat: 45.7489, lon: 21.2087, tz: 'Europe/Bucharest' },
  'Timișoara, Romania': { lat: 45.7489, lon: 21.2087, tz: 'Europe/Bucharest' },
  'Timisoara': { lat: 45.7489, lon: 21.2087, tz: 'Europe/Bucharest' },
  'Iași': { lat: 47.1585, lon: 27.6014, tz: 'Europe/Bucharest' },
  'Iași, Romania': { lat: 47.1585, lon: 27.6014, tz: 'Europe/Bucharest' },
  'Iasi': { lat: 47.1585, lon: 27.6014, tz: 'Europe/Bucharest' },
  'Constanța': { lat: 44.1598, lon: 28.6348, tz: 'Europe/Bucharest' },
  'Constanța, Romania': { lat: 44.1598, lon: 28.6348, tz: 'Europe/Bucharest' },
  'Constanta': { lat: 44.1598, lon: 28.6348, tz: 'Europe/Bucharest' },
  'Craiova': { lat: 44.3302, lon: 23.7949, tz: 'Europe/Bucharest' },
  'Craiova, Romania': { lat: 44.3302, lon: 23.7949, tz: 'Europe/Bucharest' },
  'Brașov': { lat: 45.6427, lon: 25.5887, tz: 'Europe/Bucharest' },
  'Brașov, Romania': { lat: 45.6427, lon: 25.5887, tz: 'Europe/Bucharest' },
  'Brasov': { lat: 45.6427, lon: 25.5887, tz: 'Europe/Bucharest' },
  'Galați': { lat: 45.4353, lon: 28.0080, tz: 'Europe/Bucharest' },
  'Galați, Romania': { lat: 45.4353, lon: 28.0080, tz: 'Europe/Bucharest' },
  'Galati': { lat: 45.4353, lon: 28.0080, tz: 'Europe/Bucharest' },
  'Ploiești': { lat: 44.9366, lon: 26.0131, tz: 'Europe/Bucharest' },
  'Ploiești, Romania': { lat: 44.9366, lon: 26.0131, tz: 'Europe/Bucharest' },
  'Ploiesti': { lat: 44.9366, lon: 26.0131, tz: 'Europe/Bucharest' },
  'Oradea': { lat: 47.0722, lon: 21.9212, tz: 'Europe/Bucharest' },
  'Oradea, Romania': { lat: 47.0722, lon: 21.9212, tz: 'Europe/Bucharest' },
  'Pitești': { lat: 44.8565, lon: 24.8692, tz: 'Europe/Bucharest' },
  'Pitești, Romania': { lat: 44.8565, lon: 24.8692, tz: 'Europe/Bucharest' },
  'Pitesti': { lat: 44.8565, lon: 24.8692, tz: 'Europe/Bucharest' },
  'Sibiu': { lat: 45.7983, lon: 24.1256, tz: 'Europe/Bucharest' },
  'Sibiu, Romania': { lat: 45.7983, lon: 24.1256, tz: 'Europe/Bucharest' },
  'Bacău': { lat: 46.5670, lon: 26.9146, tz: 'Europe/Bucharest' },
  'Bacău, Romania': { lat: 46.5670, lon: 26.9146, tz: 'Europe/Bucharest' },
  'Bacau': { lat: 46.5670, lon: 26.9146, tz: 'Europe/Bucharest' },
  'Târgu Mureș': { lat: 46.5386, lon: 24.5579, tz: 'Europe/Bucharest' },
  'Târgu Mureș, Romania': { lat: 46.5386, lon: 24.5579, tz: 'Europe/Bucharest' },
  'Targu Mures': { lat: 46.5386, lon: 24.5579, tz: 'Europe/Bucharest' },
  'Baia Mare': { lat: 47.6567, lon: 23.5850, tz: 'Europe/Bucharest' },
  'Baia Mare, Romania': { lat: 47.6567, lon: 23.5850, tz: 'Europe/Bucharest' },
  'Arad': { lat: 46.1866, lon: 21.3123, tz: 'Europe/Bucharest' },
  'Arad, Romania': { lat: 46.1866, lon: 21.3123, tz: 'Europe/Bucharest' },
  'Suceava': { lat: 47.6635, lon: 26.2732, tz: 'Europe/Bucharest' },
  'Suceava, Romania': { lat: 47.6635, lon: 26.2732, tz: 'Europe/Bucharest' },
  // County capitals not yet listed above
  'Botoșani': { lat: 47.7486, lon: 26.6694, tz: 'Europe/Bucharest' },
  'Botoșani, Romania': { lat: 47.7486, lon: 26.6694, tz: 'Europe/Bucharest' },
  'Botosani': { lat: 47.7486, lon: 26.6694, tz: 'Europe/Bucharest' },
  'Buzău': { lat: 45.1500, lon: 26.8333, tz: 'Europe/Bucharest' },
  'Buzău, Romania': { lat: 45.1500, lon: 26.8333, tz: 'Europe/Bucharest' },
  'Buzau': { lat: 45.1500, lon: 26.8333, tz: 'Europe/Bucharest' },
  'Satu Mare': { lat: 47.7921, lon: 22.8854, tz: 'Europe/Bucharest' },
  'Satu Mare, Romania': { lat: 47.7921, lon: 22.8854, tz: 'Europe/Bucharest' },
  'Râmnicu Vâlcea': { lat: 45.0997, lon: 24.3693, tz: 'Europe/Bucharest' },
  'Râmnicu Vâlcea, Romania': { lat: 45.0997, lon: 24.3693, tz: 'Europe/Bucharest' },
  'Ramnicu Valcea': { lat: 45.0997, lon: 24.3693, tz: 'Europe/Bucharest' },
  'Drobeta-Turnu Severin': { lat: 44.6369, lon: 22.6597, tz: 'Europe/Bucharest' },
  'Drobeta-Turnu Severin, Romania': { lat: 44.6369, lon: 22.6597, tz: 'Europe/Bucharest' },
  'Turnu Severin': { lat: 44.6369, lon: 22.6597, tz: 'Europe/Bucharest' },
  'Bistrița': { lat: 47.1333, lon: 24.5000, tz: 'Europe/Bucharest' },
  'Bistrița, Romania': { lat: 47.1333, lon: 24.5000, tz: 'Europe/Bucharest' },
  'Bistrita': { lat: 47.1333, lon: 24.5000, tz: 'Europe/Bucharest' },
  'Reșița': { lat: 45.3004, lon: 21.8893, tz: 'Europe/Bucharest' },
  'Reșița, Romania': { lat: 45.3004, lon: 21.8893, tz: 'Europe/Bucharest' },
  'Resita': { lat: 45.3004, lon: 21.8893, tz: 'Europe/Bucharest' },
  'Târgoviște': { lat: 44.9253, lon: 25.4567, tz: 'Europe/Bucharest' },
  'Târgoviște, Romania': { lat: 44.9253, lon: 25.4567, tz: 'Europe/Bucharest' },
  'Targoviste': { lat: 44.9253, lon: 25.4567, tz: 'Europe/Bucharest' },
  'Focșani': { lat: 45.6967, lon: 27.1833, tz: 'Europe/Bucharest' },
  'Focșani, Romania': { lat: 45.6967, lon: 27.1833, tz: 'Europe/Bucharest' },
  'Focsani': { lat: 45.6967, lon: 27.1833, tz: 'Europe/Bucharest' },
  'Târgu Jiu': { lat: 45.0378, lon: 23.2744, tz: 'Europe/Bucharest' },
  'Târgu Jiu, Romania': { lat: 45.0378, lon: 23.2744, tz: 'Europe/Bucharest' },
  'Targu Jiu': { lat: 45.0378, lon: 23.2744, tz: 'Europe/Bucharest' },
  'Deva': { lat: 45.8833, lon: 22.9000, tz: 'Europe/Bucharest' },
  'Deva, Romania': { lat: 45.8833, lon: 22.9000, tz: 'Europe/Bucharest' },
  'Alba Iulia': { lat: 46.0667, lon: 23.5833, tz: 'Europe/Bucharest' },
  'Alba Iulia, Romania': { lat: 46.0667, lon: 23.5833, tz: 'Europe/Bucharest' },
  'Zalău': { lat: 47.1833, lon: 23.0500, tz: 'Europe/Bucharest' },
  'Zalău, Romania': { lat: 47.1833, lon: 23.0500, tz: 'Europe/Bucharest' },
  'Zalau': { lat: 47.1833, lon: 23.0500, tz: 'Europe/Bucharest' },
  'Sfântu Gheorghe': { lat: 45.8667, lon: 25.7833, tz: 'Europe/Bucharest' },
  'Sfântu Gheorghe, Romania': { lat: 45.8667, lon: 25.7833, tz: 'Europe/Bucharest' },
  'Sfantu Gheorghe': { lat: 45.8667, lon: 25.7833, tz: 'Europe/Bucharest' },
  'Giurgiu': { lat: 43.9037, lon: 25.9699, tz: 'Europe/Bucharest' },
  'Giurgiu, Romania': { lat: 43.9037, lon: 25.9699, tz: 'Europe/Bucharest' },
  'Slobozia': { lat: 44.5640, lon: 27.3660, tz: 'Europe/Bucharest' },
  'Slobozia, Romania': { lat: 44.5640, lon: 27.3660, tz: 'Europe/Bucharest' },
  'Călărași': { lat: 44.2000, lon: 27.3333, tz: 'Europe/Bucharest' },
  'Călărași, Romania': { lat: 44.2000, lon: 27.3333, tz: 'Europe/Bucharest' },
  'Calarasi': { lat: 44.2000, lon: 27.3333, tz: 'Europe/Bucharest' },
  'Alexandria': { lat: 43.9667, lon: 25.3333, tz: 'Europe/Bucharest' },
  'Alexandria, Romania': { lat: 43.9667, lon: 25.3333, tz: 'Europe/Bucharest' },
  'Vaslui': { lat: 46.6408, lon: 27.7294, tz: 'Europe/Bucharest' },
  'Vaslui, Romania': { lat: 46.6408, lon: 27.7294, tz: 'Europe/Bucharest' },
  'Tulcea': { lat: 45.1786, lon: 28.8003, tz: 'Europe/Bucharest' },
  'Tulcea, Romania': { lat: 45.1786, lon: 28.8003, tz: 'Europe/Bucharest' },
  'Miercurea Ciuc': { lat: 46.3583, lon: 25.8028, tz: 'Europe/Bucharest' },
  'Miercurea Ciuc, Romania': { lat: 46.3583, lon: 25.8028, tz: 'Europe/Bucharest' },
  'Slatina': { lat: 44.4300, lon: 24.3600, tz: 'Europe/Bucharest' },
  'Slatina, Romania': { lat: 44.4300, lon: 24.3600, tz: 'Europe/Bucharest' },
  // Additional Romanian cities & towns
  'Petroșani': { lat: 45.4167, lon: 23.3667, tz: 'Europe/Bucharest' },
  'Petroșani, Romania': { lat: 45.4167, lon: 23.3667, tz: 'Europe/Bucharest' },
  'Petrosani': { lat: 45.4167, lon: 23.3667, tz: 'Europe/Bucharest' },
  'Mediaș': { lat: 46.1667, lon: 24.3500, tz: 'Europe/Bucharest' },
  'Mediaș, Romania': { lat: 46.1667, lon: 24.3500, tz: 'Europe/Bucharest' },
  'Medias': { lat: 46.1667, lon: 24.3500, tz: 'Europe/Bucharest' },
  'Hunedoara': { lat: 45.7500, lon: 22.9167, tz: 'Europe/Bucharest' },
  'Hunedoara, Romania': { lat: 45.7500, lon: 22.9167, tz: 'Europe/Bucharest' },
  'Lugoj': { lat: 45.6833, lon: 21.9000, tz: 'Europe/Bucharest' },
  'Lugoj, Romania': { lat: 45.6833, lon: 21.9000, tz: 'Europe/Bucharest' },
  'Dej': { lat: 47.1500, lon: 23.8667, tz: 'Europe/Bucharest' },
  'Dej, Romania': { lat: 47.1500, lon: 23.8667, tz: 'Europe/Bucharest' },
  'Turda': { lat: 46.5667, lon: 23.7833, tz: 'Europe/Bucharest' },
  'Turda, Romania': { lat: 46.5667, lon: 23.7833, tz: 'Europe/Bucharest' },
  'Câmpina': { lat: 45.1167, lon: 25.7333, tz: 'Europe/Bucharest' },
  'Câmpina, Romania': { lat: 45.1167, lon: 25.7333, tz: 'Europe/Bucharest' },
  'Campina': { lat: 45.1167, lon: 25.7333, tz: 'Europe/Bucharest' },
  'Mangalia': { lat: 43.8167, lon: 28.5833, tz: 'Europe/Bucharest' },
  'Mangalia, Romania': { lat: 43.8167, lon: 28.5833, tz: 'Europe/Bucharest' },
  'Onești': { lat: 46.2500, lon: 26.7333, tz: 'Europe/Bucharest' },
  'Onești, Romania': { lat: 46.2500, lon: 26.7333, tz: 'Europe/Bucharest' },
  'Onesti': { lat: 46.2500, lon: 26.7333, tz: 'Europe/Bucharest' },
  'Roman': { lat: 46.9167, lon: 26.9167, tz: 'Europe/Bucharest' },
  'Roman, Romania': { lat: 46.9167, lon: 26.9167, tz: 'Europe/Bucharest' },
  'Piatra Neamț': { lat: 46.9275, lon: 26.3706, tz: 'Europe/Bucharest' },
  'Piatra Neamț, Romania': { lat: 46.9275, lon: 26.3706, tz: 'Europe/Bucharest' },
  'Piatra Neamt': { lat: 46.9275, lon: 26.3706, tz: 'Europe/Bucharest' },
  'Câmpulung': { lat: 45.2667, lon: 25.0500, tz: 'Europe/Bucharest' },
  'Câmpulung, Romania': { lat: 45.2667, lon: 25.0500, tz: 'Europe/Bucharest' },
  'Campulung': { lat: 45.2667, lon: 25.0500, tz: 'Europe/Bucharest' },
  'Tecuci': { lat: 45.8500, lon: 27.4333, tz: 'Europe/Bucharest' },
  'Tecuci, Romania': { lat: 45.8500, lon: 27.4333, tz: 'Europe/Bucharest' },
  'Rădăuți': { lat: 47.8500, lon: 25.9167, tz: 'Europe/Bucharest' },
  'Rădăuți, Romania': { lat: 47.8500, lon: 25.9167, tz: 'Europe/Bucharest' },
  'Radauti': { lat: 47.8500, lon: 25.9167, tz: 'Europe/Bucharest' },
  'Câmpulung Moldovenesc': { lat: 47.5333, lon: 25.5500, tz: 'Europe/Bucharest' },
  'Campulung Moldovenesc': { lat: 47.5333, lon: 25.5500, tz: 'Europe/Bucharest' },
  'Fălticeni': { lat: 47.4600, lon: 26.3000, tz: 'Europe/Bucharest' },
  'Fălticeni, Romania': { lat: 47.4600, lon: 26.3000, tz: 'Europe/Bucharest' },
  'Falticeni': { lat: 47.4600, lon: 26.3000, tz: 'Europe/Bucharest' },
  'Vatra Dornei': { lat: 47.3500, lon: 25.3500, tz: 'Europe/Bucharest' },
  'Vatra Dornei, Romania': { lat: 47.3500, lon: 25.3500, tz: 'Europe/Bucharest' },
  'Dorohoi': { lat: 47.9500, lon: 26.4000, tz: 'Europe/Bucharest' },
  'Dorohoi, Romania': { lat: 47.9500, lon: 26.4000, tz: 'Europe/Bucharest' },
  'Huși': { lat: 46.6714, lon: 28.0597, tz: 'Europe/Bucharest' },
  'Huși, Romania': { lat: 46.6714, lon: 28.0597, tz: 'Europe/Bucharest' },
  'Husi': { lat: 46.6714, lon: 28.0597, tz: 'Europe/Bucharest' },
  'Bârlad': { lat: 46.2333, lon: 27.6667, tz: 'Europe/Bucharest' },
  'Bârlad, Romania': { lat: 46.2333, lon: 27.6667, tz: 'Europe/Bucharest' },
  'Barlad': { lat: 46.2333, lon: 27.6667, tz: 'Europe/Bucharest' },
  'Pașcani': { lat: 47.2500, lon: 26.7167, tz: 'Europe/Bucharest' },
  'Pașcani, Romania': { lat: 47.2500, lon: 26.7167, tz: 'Europe/Bucharest' },
  'Pascani': { lat: 47.2500, lon: 26.7167, tz: 'Europe/Bucharest' },
  'Caracal': { lat: 44.1167, lon: 24.3500, tz: 'Europe/Bucharest' },
  'Caracal, Romania': { lat: 44.1167, lon: 24.3500, tz: 'Europe/Bucharest' },
  'Reghin': { lat: 46.7833, lon: 24.7000, tz: 'Europe/Bucharest' },
  'Reghin, Romania': { lat: 46.7833, lon: 24.7000, tz: 'Europe/Bucharest' },
  'Sighișoara': { lat: 46.2167, lon: 24.7833, tz: 'Europe/Bucharest' },
  'Sighișoara, Romania': { lat: 46.2167, lon: 24.7833, tz: 'Europe/Bucharest' },
  'Sighisoara': { lat: 46.2167, lon: 24.7833, tz: 'Europe/Bucharest' },
  'Odorheiu Secuiesc': { lat: 46.3000, lon: 25.3000, tz: 'Europe/Bucharest' },
  'Odorheiu Secuiesc, Romania': { lat: 46.3000, lon: 25.3000, tz: 'Europe/Bucharest' },
  'Toplița': { lat: 46.9167, lon: 25.3333, tz: 'Europe/Bucharest' },
  'Toplita': { lat: 46.9167, lon: 25.3333, tz: 'Europe/Bucharest' },
  'Gheorgheni': { lat: 46.7167, lon: 25.5833, tz: 'Europe/Bucharest' },
  'Gheorgheni, Romania': { lat: 46.7167, lon: 25.5833, tz: 'Europe/Bucharest' },
  'Făgăraș': { lat: 45.8500, lon: 24.9667, tz: 'Europe/Bucharest' },
  'Făgăraș, Romania': { lat: 45.8500, lon: 24.9667, tz: 'Europe/Bucharest' },
  'Fagaras': { lat: 45.8500, lon: 24.9667, tz: 'Europe/Bucharest' },
  'Câmpia Turzii': { lat: 46.5500, lon: 23.8833, tz: 'Europe/Bucharest' },
  'Campia Turzii': { lat: 46.5500, lon: 23.8833, tz: 'Europe/Bucharest' },
  'Năvodari': { lat: 44.3167, lon: 28.6333, tz: 'Europe/Bucharest' },
  'Navodari': { lat: 44.3167, lon: 28.6333, tz: 'Europe/Bucharest' },
  'Medgidia': { lat: 44.2500, lon: 28.2667, tz: 'Europe/Bucharest' },
  'Medgidia, Romania': { lat: 44.2500, lon: 28.2667, tz: 'Europe/Bucharest' },
  'Cernavodă': { lat: 44.3333, lon: 28.0333, tz: 'Europe/Bucharest' },
  'Cernavoda': { lat: 44.3333, lon: 28.0333, tz: 'Europe/Bucharest' },
  'Oltenița': { lat: 44.0833, lon: 26.6333, tz: 'Europe/Bucharest' },
  'Oltenita': { lat: 44.0833, lon: 26.6333, tz: 'Europe/Bucharest' },
  'Turnu Măgurele': { lat: 43.7500, lon: 24.8667, tz: 'Europe/Bucharest' },
  'Turnu Magurele': { lat: 43.7500, lon: 24.8667, tz: 'Europe/Bucharest' },
  'Roșiorii de Vede': { lat: 44.1000, lon: 24.9833, tz: 'Europe/Bucharest' },
  'Rosiori de Vede': { lat: 44.1000, lon: 24.9833, tz: 'Europe/Bucharest' },
  'Fetești': { lat: 44.3833, lon: 27.8333, tz: 'Europe/Bucharest' },
  'Fetesti': { lat: 44.3833, lon: 27.8333, tz: 'Europe/Bucharest' },
  'Urziceni': { lat: 44.7167, lon: 26.6333, tz: 'Europe/Bucharest' },
  'Urziceni, Romania': { lat: 44.7167, lon: 26.6333, tz: 'Europe/Bucharest' },
  'Sebeș': { lat: 45.9667, lon: 23.5667, tz: 'Europe/Bucharest' },
  'Sebes': { lat: 45.9667, lon: 23.5667, tz: 'Europe/Bucharest' },
  'Aiud': { lat: 46.3000, lon: 23.7167, tz: 'Europe/Bucharest' },
  'Aiud, Romania': { lat: 46.3000, lon: 23.7167, tz: 'Europe/Bucharest' },
  'Blaj': { lat: 46.1667, lon: 23.9167, tz: 'Europe/Bucharest' },
  'Blaj, Romania': { lat: 46.1667, lon: 23.9167, tz: 'Europe/Bucharest' },
  'Orăștie': { lat: 45.8333, lon: 23.2000, tz: 'Europe/Bucharest' },
  'Orastie': { lat: 45.8333, lon: 23.2000, tz: 'Europe/Bucharest' },
  'Lupeni': { lat: 45.3500, lon: 23.2333, tz: 'Europe/Bucharest' },
  'Lupeni, Romania': { lat: 45.3500, lon: 23.2333, tz: 'Europe/Bucharest' },
  'Vulcan': { lat: 45.3833, lon: 23.2667, tz: 'Europe/Bucharest' },
  'Vulcan, Romania': { lat: 45.3833, lon: 23.2667, tz: 'Europe/Bucharest' },
  'Petrila': { lat: 45.4500, lon: 23.4167, tz: 'Europe/Bucharest' },
  'Petrila, Romania': { lat: 45.4500, lon: 23.4167, tz: 'Europe/Bucharest' },
  'Brad': { lat: 46.1333, lon: 22.7833, tz: 'Europe/Bucharest' },
  'Brad, Romania': { lat: 46.1333, lon: 22.7833, tz: 'Europe/Bucharest' },
  'Caransebeș': { lat: 45.4167, lon: 22.2167, tz: 'Europe/Bucharest' },
  'Caransebes': { lat: 45.4167, lon: 22.2167, tz: 'Europe/Bucharest' },
  'Orșova': { lat: 44.7167, lon: 22.3833, tz: 'Europe/Bucharest' },
  'Orsova': { lat: 44.7167, lon: 22.3833, tz: 'Europe/Bucharest' },
  'Moldova Nouă': { lat: 44.7333, lon: 21.6667, tz: 'Europe/Bucharest' },
  'Moldova Noua': { lat: 44.7333, lon: 21.6667, tz: 'Europe/Bucharest' },
  'Motru': { lat: 44.8000, lon: 22.9667, tz: 'Europe/Bucharest' },
  'Motru, Romania': { lat: 44.8000, lon: 22.9667, tz: 'Europe/Bucharest' },
  'Carei': { lat: 47.6833, lon: 22.4667, tz: 'Europe/Bucharest' },
  'Carei, Romania': { lat: 47.6833, lon: 22.4667, tz: 'Europe/Bucharest' },
  'Negrești-Oaș': { lat: 47.8667, lon: 23.4167, tz: 'Europe/Bucharest' },
  'Negresti-Oas': { lat: 47.8667, lon: 23.4167, tz: 'Europe/Bucharest' },
  'Sighetu Marmației': { lat: 47.9333, lon: 23.8833, tz: 'Europe/Bucharest' },
  'Sighetu Marmatiei': { lat: 47.9333, lon: 23.8833, tz: 'Europe/Bucharest' },
  'Sighetul Marmației': { lat: 47.9333, lon: 23.8833, tz: 'Europe/Bucharest' },
  'Borșa': { lat: 47.6500, lon: 24.6667, tz: 'Europe/Bucharest' },
  'Borsa': { lat: 47.6500, lon: 24.6667, tz: 'Europe/Bucharest' },
  'Vișeu de Sus': { lat: 47.7167, lon: 24.4167, tz: 'Europe/Bucharest' },
  'Viseu de Sus': { lat: 47.7167, lon: 24.4167, tz: 'Europe/Bucharest' },
  'Săcele': { lat: 45.6167, lon: 25.6833, tz: 'Europe/Bucharest' },
  'Sacele': { lat: 45.6167, lon: 25.6833, tz: 'Europe/Bucharest' },
  'Codlea': { lat: 45.6833, lon: 25.4500, tz: 'Europe/Bucharest' },
  'Codlea, Romania': { lat: 45.6833, lon: 25.4500, tz: 'Europe/Bucharest' },
  'Zărnești': { lat: 45.5667, lon: 25.3333, tz: 'Europe/Bucharest' },
  'Zarnesti': { lat: 45.5667, lon: 25.3333, tz: 'Europe/Bucharest' },
  'Râșnov': { lat: 45.5833, lon: 25.4500, tz: 'Europe/Bucharest' },
  'Rasnov': { lat: 45.5833, lon: 25.4500, tz: 'Europe/Bucharest' },
  'Mioveni': { lat: 44.9500, lon: 24.9333, tz: 'Europe/Bucharest' },
  'Mioveni, Romania': { lat: 44.9500, lon: 24.9333, tz: 'Europe/Bucharest' },
  'Curtea de Argeș': { lat: 45.1333, lon: 24.6667, tz: 'Europe/Bucharest' },
  'Curtea de Arges': { lat: 45.1333, lon: 24.6667, tz: 'Europe/Bucharest' },
  'Câmpulung Muscel': { lat: 45.2667, lon: 25.0500, tz: 'Europe/Bucharest' },
  'Câmpulung Muscel, Romania': { lat: 45.2667, lon: 25.0500, tz: 'Europe/Bucharest' },
  'Voluntari': { lat: 44.4833, lon: 26.1833, tz: 'Europe/Bucharest' },
  'Voluntari, Romania': { lat: 44.4833, lon: 26.1833, tz: 'Europe/Bucharest' },
  'Pantelimon': { lat: 44.4500, lon: 26.2000, tz: 'Europe/Bucharest' },
  'Pantelimon, Romania': { lat: 44.4500, lon: 26.2000, tz: 'Europe/Bucharest' },
  'Popești-Leordeni': { lat: 44.3833, lon: 26.1667, tz: 'Europe/Bucharest' },
  'Popesti-Leordeni': { lat: 44.3833, lon: 26.1667, tz: 'Europe/Bucharest' },
  'Buftea': { lat: 44.5667, lon: 25.9500, tz: 'Europe/Bucharest' },
  'Buftea, Romania': { lat: 44.5667, lon: 25.9500, tz: 'Europe/Bucharest' },
  'Otopeni': { lat: 44.5500, lon: 26.0833, tz: 'Europe/Bucharest' },
  'Otopeni, Romania': { lat: 44.5500, lon: 26.0833, tz: 'Europe/Bucharest' },
  'Bragadiru': { lat: 44.3833, lon: 26.0333, tz: 'Europe/Bucharest' },
  'Bragadiru, Romania': { lat: 44.3833, lon: 26.0333, tz: 'Europe/Bucharest' },
  'Chitila': { lat: 44.5000, lon: 25.9833, tz: 'Europe/Bucharest' },
  'Chitila, Romania': { lat: 44.5000, lon: 25.9833, tz: 'Europe/Bucharest' },
  'Măgurele': { lat: 44.3500, lon: 26.0333, tz: 'Europe/Bucharest' },
  'Magurele': { lat: 44.3500, lon: 26.0333, tz: 'Europe/Bucharest' },

  // United Kingdom
  'Manchester': { lat: 53.4808, lon: -2.2426, tz: 'Europe/London' },
  'Manchester, UK': { lat: 53.4808, lon: -2.2426, tz: 'Europe/London' },
  'Birmingham': { lat: 52.4862, lon: -1.8904, tz: 'Europe/London' },
  'Birmingham, UK': { lat: 52.4862, lon: -1.8904, tz: 'Europe/London' },
  'Liverpool': { lat: 53.4084, lon: -2.9916, tz: 'Europe/London' },
  'Liverpool, UK': { lat: 53.4084, lon: -2.9916, tz: 'Europe/London' },
  'Edinburgh': { lat: 55.9533, lon: -3.1883, tz: 'Europe/London' },
  'Edinburgh, UK': { lat: 55.9533, lon: -3.1883, tz: 'Europe/London' },
  'Glasgow': { lat: 55.8642, lon: -4.2518, tz: 'Europe/London' },
  'Glasgow, UK': { lat: 55.8642, lon: -4.2518, tz: 'Europe/London' },

  // Ireland
  'Dublin': { lat: 53.3498, lon: -6.2603, tz: 'Europe/Dublin' },
  'Dublin, Ireland': { lat: 53.3498, lon: -6.2603, tz: 'Europe/Dublin' },
  'Cork': { lat: 51.8985, lon: -8.4756, tz: 'Europe/Dublin' },
  'Cork, Ireland': { lat: 51.8985, lon: -8.4756, tz: 'Europe/Dublin' },

  // France
  'Lyon': { lat: 45.7640, lon: 4.8357, tz: 'Europe/Paris' },
  'Lyon, France': { lat: 45.7640, lon: 4.8357, tz: 'Europe/Paris' },
  'Marseille': { lat: 43.2965, lon: 5.3698, tz: 'Europe/Paris' },
  'Marseille, France': { lat: 43.2965, lon: 5.3698, tz: 'Europe/Paris' },
  'Nice': { lat: 43.7102, lon: 7.2620, tz: 'Europe/Paris' },
  'Nice, France': { lat: 43.7102, lon: 7.2620, tz: 'Europe/Paris' },
  'Bordeaux': { lat: 44.8378, lon: -0.5792, tz: 'Europe/Paris' },
  'Bordeaux, France': { lat: 44.8378, lon: -0.5792, tz: 'Europe/Paris' },

  // Germany
  'Munich': { lat: 48.1351, lon: 11.5820, tz: 'Europe/Berlin' },
  'Munich, Germany': { lat: 48.1351, lon: 11.5820, tz: 'Europe/Berlin' },
  'München': { lat: 48.1351, lon: 11.5820, tz: 'Europe/Berlin' },
  'Frankfurt': { lat: 50.1109, lon: 8.6821, tz: 'Europe/Berlin' },
  'Frankfurt, Germany': { lat: 50.1109, lon: 8.6821, tz: 'Europe/Berlin' },
  'Hamburg': { lat: 53.5511, lon: 9.9937, tz: 'Europe/Berlin' },
  'Hamburg, Germany': { lat: 53.5511, lon: 9.9937, tz: 'Europe/Berlin' },
  'Cologne': { lat: 50.9375, lon: 6.9603, tz: 'Europe/Berlin' },
  'Cologne, Germany': { lat: 50.9375, lon: 6.9603, tz: 'Europe/Berlin' },

  // Italy
  'Milan': { lat: 45.4642, lon: 9.1900, tz: 'Europe/Rome' },
  'Milan, Italy': { lat: 45.4642, lon: 9.1900, tz: 'Europe/Rome' },
  'Milano': { lat: 45.4642, lon: 9.1900, tz: 'Europe/Rome' },
  'Naples': { lat: 40.8518, lon: 14.2681, tz: 'Europe/Rome' },
  'Naples, Italy': { lat: 40.8518, lon: 14.2681, tz: 'Europe/Rome' },
  'Florence': { lat: 43.7696, lon: 11.2558, tz: 'Europe/Rome' },
  'Florence, Italy': { lat: 43.7696, lon: 11.2558, tz: 'Europe/Rome' },
  'Venice': { lat: 45.4408, lon: 12.3155, tz: 'Europe/Rome' },
  'Venice, Italy': { lat: 45.4408, lon: 12.3155, tz: 'Europe/Rome' },

  // Spain
  'Barcelona': { lat: 41.3851, lon: 2.1734, tz: 'Europe/Madrid' },
  'Barcelona, Spain': { lat: 41.3851, lon: 2.1734, tz: 'Europe/Madrid' },
  'Valencia': { lat: 39.4699, lon: -0.3763, tz: 'Europe/Madrid' },
  'Valencia, Spain': { lat: 39.4699, lon: -0.3763, tz: 'Europe/Madrid' },
  'Seville': { lat: 37.3891, lon: -5.9845, tz: 'Europe/Madrid' },
  'Seville, Spain': { lat: 37.3891, lon: -5.9845, tz: 'Europe/Madrid' },
  'Malaga': { lat: 36.7213, lon: -4.4214, tz: 'Europe/Madrid' },
  'Malaga, Spain': { lat: 36.7213, lon: -4.4214, tz: 'Europe/Madrid' },

  // Portugal
  'Lisbon': { lat: 38.7223, lon: -9.1393, tz: 'Europe/Lisbon' },
  'Lisbon, Portugal': { lat: 38.7223, lon: -9.1393, tz: 'Europe/Lisbon' },
  'Porto': { lat: 41.1579, lon: -8.6291, tz: 'Europe/Lisbon' },
  'Porto, Portugal': { lat: 41.1579, lon: -8.6291, tz: 'Europe/Lisbon' },

  // Switzerland
  'Zurich': { lat: 47.3769, lon: 8.5417, tz: 'Europe/Zurich' },
  'Zurich, Switzerland': { lat: 47.3769, lon: 8.5417, tz: 'Europe/Zurich' },
  'Geneva': { lat: 46.2044, lon: 6.1432, tz: 'Europe/Zurich' },
  'Geneva, Switzerland': { lat: 46.2044, lon: 6.1432, tz: 'Europe/Zurich' },
  'Bern': { lat: 46.9480, lon: 7.4474, tz: 'Europe/Zurich' },
  'Bern, Switzerland': { lat: 46.9480, lon: 7.4474, tz: 'Europe/Zurich' },

  // Austria
  'Vienna': { lat: 48.2082, lon: 16.3738, tz: 'Europe/Vienna' },
  'Vienna, Austria': { lat: 48.2082, lon: 16.3738, tz: 'Europe/Vienna' },
  'Salzburg': { lat: 47.8095, lon: 13.0550, tz: 'Europe/Vienna' },
  'Salzburg, Austria': { lat: 47.8095, lon: 13.0550, tz: 'Europe/Vienna' },

  // Poland
  'Warsaw': { lat: 52.2297, lon: 21.0122, tz: 'Europe/Warsaw' },
  'Warsaw, Poland': { lat: 52.2297, lon: 21.0122, tz: 'Europe/Warsaw' },
  'Krakow': { lat: 50.0647, lon: 19.9450, tz: 'Europe/Warsaw' },
  'Krakow, Poland': { lat: 50.0647, lon: 19.9450, tz: 'Europe/Warsaw' },

  // Czech Republic
  'Prague': { lat: 50.0755, lon: 14.4378, tz: 'Europe/Prague' },
  'Prague, Czech Republic': { lat: 50.0755, lon: 14.4378, tz: 'Europe/Prague' },

  // Hungary
  'Budapest': { lat: 47.4979, lon: 19.0402, tz: 'Europe/Budapest' },
  'Budapest, Hungary': { lat: 47.4979, lon: 19.0402, tz: 'Europe/Budapest' },

  // Greece
  'Thessaloniki': { lat: 40.6401, lon: 22.9444, tz: 'Europe/Athens' },
  'Thessaloniki, Greece': { lat: 40.6401, lon: 22.9444, tz: 'Europe/Athens' },

  // Scandinavia
  'Stockholm': { lat: 59.3293, lon: 18.0686, tz: 'Europe/Stockholm' },
  'Stockholm, Sweden': { lat: 59.3293, lon: 18.0686, tz: 'Europe/Stockholm' },
  'Oslo': { lat: 59.9139, lon: 10.7522, tz: 'Europe/Oslo' },
  'Oslo, Norway': { lat: 59.9139, lon: 10.7522, tz: 'Europe/Oslo' },
  'Copenhagen': { lat: 55.6761, lon: 12.5683, tz: 'Europe/Copenhagen' },
  'Copenhagen, Denmark': { lat: 55.6761, lon: 12.5683, tz: 'Europe/Copenhagen' },
  'Helsinki': { lat: 60.1699, lon: 24.9384, tz: 'Europe/Helsinki' },
  'Helsinki, Finland': { lat: 60.1699, lon: 24.9384, tz: 'Europe/Helsinki' },

  // Belgium & Netherlands
  'Brussels': { lat: 50.8503, lon: 4.3517, tz: 'Europe/Brussels' },
  'Brussels, Belgium': { lat: 50.8503, lon: 4.3517, tz: 'Europe/Brussels' },
  'Rotterdam': { lat: 51.9244, lon: 4.4777, tz: 'Europe/Amsterdam' },
  'Rotterdam, Netherlands': { lat: 51.9244, lon: 4.4777, tz: 'Europe/Amsterdam' },

  // USA - Major cities
  'Houston, TX': { lat: 29.7604, lon: -95.3698, tz: 'America/Chicago' },
  'Houston': { lat: 29.7604, lon: -95.3698, tz: 'America/Chicago' },
  'Phoenix, AZ': { lat: 33.4484, lon: -112.0740, tz: 'America/Phoenix' },
  'Phoenix': { lat: 33.4484, lon: -112.0740, tz: 'America/Phoenix' },
  'Philadelphia, PA': { lat: 39.9526, lon: -75.1652, tz: 'America/New_York' },
  'Philadelphia': { lat: 39.9526, lon: -75.1652, tz: 'America/New_York' },
  'San Antonio, TX': { lat: 29.4241, lon: -98.4936, tz: 'America/Chicago' },
  'San Antonio': { lat: 29.4241, lon: -98.4936, tz: 'America/Chicago' },
  'San Diego, CA': { lat: 32.7157, lon: -117.1611, tz: 'America/Los_Angeles' },
  'San Diego': { lat: 32.7157, lon: -117.1611, tz: 'America/Los_Angeles' },
  'Dallas, TX': { lat: 32.7767, lon: -96.7970, tz: 'America/Chicago' },
  'Dallas': { lat: 32.7767, lon: -96.7970, tz: 'America/Chicago' },
  'San Jose, CA': { lat: 37.3382, lon: -121.8863, tz: 'America/Los_Angeles' },
  'San Jose': { lat: 37.3382, lon: -121.8863, tz: 'America/Los_Angeles' },
  'Austin, TX': { lat: 30.2672, lon: -97.7431, tz: 'America/Chicago' },
  'Austin': { lat: 30.2672, lon: -97.7431, tz: 'America/Chicago' },
  'Jacksonville, FL': { lat: 30.3322, lon: -81.6557, tz: 'America/New_York' },
  'Jacksonville': { lat: 30.3322, lon: -81.6557, tz: 'America/New_York' },
  'Fort Worth, TX': { lat: 32.7555, lon: -97.3308, tz: 'America/Chicago' },
  'Fort Worth': { lat: 32.7555, lon: -97.3308, tz: 'America/Chicago' },
  'Columbus, OH': { lat: 39.9612, lon: -82.9988, tz: 'America/New_York' },
  'Columbus': { lat: 39.9612, lon: -82.9988, tz: 'America/New_York' },
  'Charlotte, NC': { lat: 35.2271, lon: -80.8431, tz: 'America/New_York' },
  'Charlotte': { lat: 35.2271, lon: -80.8431, tz: 'America/New_York' },
  'Indianapolis, IN': { lat: 39.7684, lon: -86.1581, tz: 'America/Indiana/Indianapolis' },
  'Indianapolis': { lat: 39.7684, lon: -86.1581, tz: 'America/Indiana/Indianapolis' },
  'Denver, CO': { lat: 39.7392, lon: -104.9903, tz: 'America/Denver' },
  'Denver': { lat: 39.7392, lon: -104.9903, tz: 'America/Denver' },
  'Washington, DC': { lat: 38.9072, lon: -77.0369, tz: 'America/New_York' },
  'Washington': { lat: 38.9072, lon: -77.0369, tz: 'America/New_York' },
  'Nashville, TN': { lat: 36.1627, lon: -86.7816, tz: 'America/Chicago' },
  'Nashville': { lat: 36.1627, lon: -86.7816, tz: 'America/Chicago' },
  'Detroit, MI': { lat: 42.3314, lon: -83.0458, tz: 'America/Detroit' },
  'Detroit': { lat: 42.3314, lon: -83.0458, tz: 'America/Detroit' },
  'Portland, OR': { lat: 45.5152, lon: -122.6784, tz: 'America/Los_Angeles' },
  'Portland': { lat: 45.5152, lon: -122.6784, tz: 'America/Los_Angeles' },
  'Las Vegas, NV': { lat: 36.1699, lon: -115.1398, tz: 'America/Los_Angeles' },
  'Las Vegas': { lat: 36.1699, lon: -115.1398, tz: 'America/Los_Angeles' },
  'Atlanta, GA': { lat: 33.7490, lon: -84.3880, tz: 'America/New_York' },
  'Atlanta': { lat: 33.7490, lon: -84.3880, tz: 'America/New_York' },
  'Minneapolis, MN': { lat: 44.9778, lon: -93.2650, tz: 'America/Chicago' },
  'Minneapolis': { lat: 44.9778, lon: -93.2650, tz: 'America/Chicago' },
  'Tampa, FL': { lat: 27.9506, lon: -82.4572, tz: 'America/New_York' },
  'Tampa': { lat: 27.9506, lon: -82.4572, tz: 'America/New_York' },
  'Orlando, FL': { lat: 28.5383, lon: -81.3792, tz: 'America/New_York' },
  'Orlando': { lat: 28.5383, lon: -81.3792, tz: 'America/New_York' },
  'New Orleans, LA': { lat: 29.9511, lon: -90.0715, tz: 'America/Chicago' },
  'New Orleans': { lat: 29.9511, lon: -90.0715, tz: 'America/Chicago' },
  'Cleveland, OH': { lat: 41.4993, lon: -81.6944, tz: 'America/New_York' },
  'Cleveland': { lat: 41.4993, lon: -81.6944, tz: 'America/New_York' },
  'Pittsburgh, PA': { lat: 40.4406, lon: -79.9959, tz: 'America/New_York' },
  'Pittsburgh': { lat: 40.4406, lon: -79.9959, tz: 'America/New_York' },

  // Canada
  'Vancouver': { lat: 49.2827, lon: -123.1207, tz: 'America/Vancouver' },
  'Vancouver, Canada': { lat: 49.2827, lon: -123.1207, tz: 'America/Vancouver' },
  'Montreal': { lat: 45.5017, lon: -73.5673, tz: 'America/Montreal' },
  'Montreal, Canada': { lat: 45.5017, lon: -73.5673, tz: 'America/Montreal' },
  'Calgary': { lat: 51.0447, lon: -114.0719, tz: 'America/Edmonton' },
  'Calgary, Canada': { lat: 51.0447, lon: -114.0719, tz: 'America/Edmonton' },
  'Ottawa': { lat: 45.4215, lon: -75.6972, tz: 'America/Toronto' },
  'Ottawa, Canada': { lat: 45.4215, lon: -75.6972, tz: 'America/Toronto' },

  // Australia
  'Melbourne': { lat: -37.8136, lon: 144.9631, tz: 'Australia/Melbourne' },
  'Melbourne, Australia': { lat: -37.8136, lon: 144.9631, tz: 'Australia/Melbourne' },
  'Brisbane': { lat: -27.4698, lon: 153.0251, tz: 'Australia/Brisbane' },
  'Brisbane, Australia': { lat: -27.4698, lon: 153.0251, tz: 'Australia/Brisbane' },
  'Perth': { lat: -31.9505, lon: 115.8605, tz: 'Australia/Perth' },
  'Perth, Australia': { lat: -31.9505, lon: 115.8605, tz: 'Australia/Perth' },
  'Adelaide': { lat: -34.9285, lon: 138.6007, tz: 'Australia/Adelaide' },
  'Adelaide, Australia': { lat: -34.9285, lon: 138.6007, tz: 'Australia/Adelaide' },

  // New Zealand
  'Auckland': { lat: -36.8485, lon: 174.7633, tz: 'Pacific/Auckland' },
  'Auckland, New Zealand': { lat: -36.8485, lon: 174.7633, tz: 'Pacific/Auckland' },
  'Wellington': { lat: -41.2865, lon: 174.7762, tz: 'Pacific/Auckland' },
  'Wellington, New Zealand': { lat: -41.2865, lon: 174.7762, tz: 'Pacific/Auckland' },

  // Asia
  'Delhi': { lat: 28.7041, lon: 77.1025, tz: 'Asia/Kolkata' },
  'Delhi, India': { lat: 28.7041, lon: 77.1025, tz: 'Asia/Kolkata' },
  'New Delhi': { lat: 28.6139, lon: 77.2090, tz: 'Asia/Kolkata' },
  'New Delhi, India': { lat: 28.6139, lon: 77.2090, tz: 'Asia/Kolkata' },
  'Bangalore': { lat: 12.9716, lon: 77.5946, tz: 'Asia/Kolkata' },
  'Bangalore, India': { lat: 12.9716, lon: 77.5946, tz: 'Asia/Kolkata' },
  'Chennai': { lat: 13.0827, lon: 80.2707, tz: 'Asia/Kolkata' },
  'Chennai, India': { lat: 13.0827, lon: 80.2707, tz: 'Asia/Kolkata' },
  'Kolkata': { lat: 22.5726, lon: 88.3639, tz: 'Asia/Kolkata' },
  'Kolkata, India': { lat: 22.5726, lon: 88.3639, tz: 'Asia/Kolkata' },
  'Osaka': { lat: 34.6937, lon: 135.5023, tz: 'Asia/Tokyo' },
  'Osaka, Japan': { lat: 34.6937, lon: 135.5023, tz: 'Asia/Tokyo' },
  'Jakarta': { lat: -6.2088, lon: 106.8456, tz: 'Asia/Jakarta' },
  'Jakarta, Indonesia': { lat: -6.2088, lon: 106.8456, tz: 'Asia/Jakarta' },
  'Manila': { lat: 14.5995, lon: 120.9842, tz: 'Asia/Manila' },
  'Manila, Philippines': { lat: 14.5995, lon: 120.9842, tz: 'Asia/Manila' },
  'Kuala Lumpur': { lat: 3.1390, lon: 101.6869, tz: 'Asia/Kuala_Lumpur' },
  'Kuala Lumpur, Malaysia': { lat: 3.1390, lon: 101.6869, tz: 'Asia/Kuala_Lumpur' },
  'Ho Chi Minh City': { lat: 10.8231, lon: 106.6297, tz: 'Asia/Ho_Chi_Minh' },
  'Ho Chi Minh City, Vietnam': { lat: 10.8231, lon: 106.6297, tz: 'Asia/Ho_Chi_Minh' },
  'Hanoi': { lat: 21.0285, lon: 105.8542, tz: 'Asia/Ho_Chi_Minh' },
  'Hanoi, Vietnam': { lat: 21.0285, lon: 105.8542, tz: 'Asia/Ho_Chi_Minh' },
  'Taipei': { lat: 25.0330, lon: 121.5654, tz: 'Asia/Taipei' },
  'Taipei, Taiwan': { lat: 25.0330, lon: 121.5654, tz: 'Asia/Taipei' },

  // Middle East
  'Tel Aviv': { lat: 32.0853, lon: 34.7818, tz: 'Asia/Jerusalem' },
  'Tel Aviv, Israel': { lat: 32.0853, lon: 34.7818, tz: 'Asia/Jerusalem' },
  'Jerusalem': { lat: 31.7683, lon: 35.2137, tz: 'Asia/Jerusalem' },
  'Jerusalem, Israel': { lat: 31.7683, lon: 35.2137, tz: 'Asia/Jerusalem' },
  'Riyadh': { lat: 24.7136, lon: 46.6753, tz: 'Asia/Riyadh' },
  'Riyadh, Saudi Arabia': { lat: 24.7136, lon: 46.6753, tz: 'Asia/Riyadh' },
  'Jeddah': { lat: 21.2854, lon: 39.2376, tz: 'Asia/Riyadh' },
  'Jeddah, Saudi Arabia': { lat: 21.2854, lon: 39.2376, tz: 'Asia/Riyadh' },
  'Doha': { lat: 25.2854, lon: 51.5310, tz: 'Asia/Qatar' },
  'Doha, Qatar': { lat: 25.2854, lon: 51.5310, tz: 'Asia/Qatar' },
  'Abu Dhabi': { lat: 24.4539, lon: 54.3773, tz: 'Asia/Dubai' },
  'Abu Dhabi, UAE': { lat: 24.4539, lon: 54.3773, tz: 'Asia/Dubai' },
  'Kuwait City': { lat: 29.3759, lon: 47.9774, tz: 'Asia/Kuwait' },
  'Kuwait City, Kuwait': { lat: 29.3759, lon: 47.9774, tz: 'Asia/Kuwait' },

  // South America
  'São Paulo': { lat: -23.5505, lon: -46.6333, tz: 'America/Sao_Paulo' },
  'São Paulo, Brazil': { lat: -23.5505, lon: -46.6333, tz: 'America/Sao_Paulo' },
  'Sao Paulo': { lat: -23.5505, lon: -46.6333, tz: 'America/Sao_Paulo' },
  'Lima': { lat: -12.0464, lon: -77.0428, tz: 'America/Lima' },
  'Lima, Peru': { lat: -12.0464, lon: -77.0428, tz: 'America/Lima' },
  'Bogota': { lat: 4.7110, lon: -74.0721, tz: 'America/Bogota' },
  'Bogota, Colombia': { lat: 4.7110, lon: -74.0721, tz: 'America/Bogota' },
  'Santiago': { lat: -33.4489, lon: -70.6693, tz: 'America/Santiago' },
  'Santiago, Chile': { lat: -33.4489, lon: -70.6693, tz: 'America/Santiago' },
  'Caracas': { lat: 10.4806, lon: -66.9036, tz: 'America/Caracas' },
  'Caracas, Venezuela': { lat: 10.4806, lon: -66.9036, tz: 'America/Caracas' },

  // Africa
  'Johannesburg': { lat: -26.2041, lon: 28.0473, tz: 'Africa/Johannesburg' },
  'Johannesburg, South Africa': { lat: -26.2041, lon: 28.0473, tz: 'Africa/Johannesburg' },
  'Lagos': { lat: 6.5244, lon: 3.3792, tz: 'Africa/Lagos' },
  'Lagos, Nigeria': { lat: 6.5244, lon: 3.3792, tz: 'Africa/Lagos' },
  'Nairobi': { lat: -1.2921, lon: 36.8219, tz: 'Africa/Nairobi' },
  'Nairobi, Kenya': { lat: -1.2921, lon: 36.8219, tz: 'Africa/Nairobi' },
  'Casablanca': { lat: 33.5731, lon: -7.5898, tz: 'Africa/Casablanca' },
  'Casablanca, Morocco': { lat: 33.5731, lon: -7.5898, tz: 'Africa/Casablanca' },
  'Addis Ababa': { lat: 9.0320, lon: 38.7469, tz: 'Africa/Addis_Ababa' },
  'Addis Ababa, Ethiopia': { lat: 9.0320, lon: 38.7469, tz: 'Africa/Addis_Ababa' },
  'Accra': { lat: 5.6037, lon: -0.1870, tz: 'Africa/Accra' },
  'Accra, Ghana': { lat: 5.6037, lon: -0.1870, tz: 'Africa/Accra' },
};

/**
 * Look up city coordinates from built-in database
 */
export function lookupCity(cityName) {
  const normalized = cityName.trim();
  const cityData = CITY_DATABASE[normalized];

  if (cityData) {
    return {
      cityName: normalized,
      latitude: cityData.lat,
      longitude: cityData.lon,
      timezone: cityData.tz,
      utcOffset: 0 // Will be calculated dynamically
    };
  }

  return null;
}

/**
 * Calculate UTC offset for a given date and timezone.
 *
 * Reads the civil clock in the target timezone with Intl.formatToParts and
 * compares it against the instant itself — no string parsing and no reference
 * to the device timezone, so the result is identical on every device (the old
 * toLocaleString round-trip could drift 1h when the rendered strings straddled
 * a DST change in the DEVICE zone).
 */
export function getUTCOffset(date, timezone) {
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(date);
    const get = (type) => Number(parts.find(p => p.type === type)?.value);
    const civilAsUTC = Date.UTC(
      get('year'), get('month') - 1, get('day'),
      get('hour') % 24, get('minute'), get('second')
    );
    // Round to whole minutes to absorb sub-second truncation
    return Math.round((civilAsUTC - date.getTime()) / 60000) / 60;
  } catch (error) {
    console.warn(`Could not determine timezone offset for ${timezone}`, error);
    return 0;
  }
}

/**
 * Convert local time to UTC for a specific timezone
 */
export function localToUTC(localDate, timezone) {
  try {
    // Get the UTC offset for this date/timezone
    const offset = getUTCOffset(localDate, timezone);

    // Create a new date adjusted to UTC
    const utcTime = new Date(localDate.getTime() - offset * 60 * 60 * 1000);
    return utcTime;
  } catch (error) {
    console.warn('Could not convert to UTC, using original date', error);
    return localDate;
  }
}

/**
 * Get timezone name for coordinates (approximate)
 */
export function getTimezoneFromCoordinates(latitude, longitude) {
  // Simplified timezone estimation based on longitude
  // For more accurate results, you'd need a timezone database
  const hoursFromGMT = Math.round(longitude / 15);

  // Try to match with known timezones
  for (const [, data] of Object.entries(CITY_DATABASE)) {
    const latDiff = Math.abs(data.lat - latitude);
    const lonDiff = Math.abs(data.lon - longitude);

    // If within ~1 degree, assume same timezone
    if (latDiff < 1 && lonDiff < 1) {
      return data.tz;
    }
  }

  // Fallback: return UTC offset string
  return `Etc/GMT${hoursFromGMT >= 0 ? '-' : '+'}${Math.abs(hoursFromGMT)}`;
}

/**
 * Get list of all cities in database (for autocomplete)
 */
export function getCityList() {
  return Object.keys(CITY_DATABASE).sort();
}

// ---------------------------------------------------------------------------
// Country-code → IANA timezone mapping (for single-timezone countries)
// Everywhere else (US, CA, RU, AU, BR, MX, ID and unlisted countries) the
// coordinates decide, through tz-lookup
// ---------------------------------------------------------------------------
const COUNTRY_TIMEZONE = {
  RO: 'Europe/Bucharest', MD: 'Europe/Chisinau', BG: 'Europe/Sofia',
  GR: 'Europe/Athens', CY: 'Asia/Nicosia', TR: 'Europe/Istanbul',
  GB: 'Europe/London', IE: 'Europe/Dublin', IS: 'Atlantic/Reykjavik',
  FR: 'Europe/Paris', BE: 'Europe/Brussels', NL: 'Europe/Amsterdam',
  LU: 'Europe/Luxembourg', MC: 'Europe/Monaco',
  DE: 'Europe/Berlin', AT: 'Europe/Vienna', CH: 'Europe/Zurich',
  LI: 'Europe/Vaduz',
  IT: 'Europe/Rome', SM: 'Europe/San_Marino', VA: 'Europe/Vatican',
  ES: 'Europe/Madrid', PT: 'Europe/Lisbon', AD: 'Europe/Andorra',
  PL: 'Europe/Warsaw', CZ: 'Europe/Prague', SK: 'Europe/Bratislava',
  HU: 'Europe/Budapest', SI: 'Europe/Ljubljana', HR: 'Europe/Zagreb',
  BA: 'Europe/Sarajevo', RS: 'Europe/Belgrade', ME: 'Europe/Podgorica',
  MK: 'Europe/Skopje', AL: 'Europe/Tirane', XK: 'Europe/Belgrade',
  SE: 'Europe/Stockholm', NO: 'Europe/Oslo', DK: 'Europe/Copenhagen',
  FI: 'Europe/Helsinki', EE: 'Europe/Tallinn', LV: 'Europe/Riga',
  LT: 'Europe/Vilnius', BY: 'Europe/Minsk', UA: 'Europe/Kyiv',
  MT: 'Europe/Malta',
  IL: 'Asia/Jerusalem', JO: 'Asia/Amman', LB: 'Asia/Beirut',
  AE: 'Asia/Dubai', SA: 'Asia/Riyadh', QA: 'Asia/Qatar',
  KW: 'Asia/Kuwait', BH: 'Asia/Bahrain', OM: 'Asia/Muscat',
  IN: 'Asia/Kolkata', PK: 'Asia/Karachi', BD: 'Asia/Dhaka',
  LK: 'Asia/Colombo', NP: 'Asia/Kathmandu',
  TH: 'Asia/Bangkok', VN: 'Asia/Ho_Chi_Minh', SG: 'Asia/Singapore',
  MY: 'Asia/Kuala_Lumpur', PH: 'Asia/Manila',
  JP: 'Asia/Tokyo', KR: 'Asia/Seoul', TW: 'Asia/Taipei',
  HK: 'Asia/Hong_Kong',
  NZ: 'Pacific/Auckland',
  EG: 'Africa/Cairo', ZA: 'Africa/Johannesburg', NG: 'Africa/Lagos',
  KE: 'Africa/Nairobi', GH: 'Africa/Accra', MA: 'Africa/Casablanca',
  ET: 'Africa/Addis_Ababa', TZ: 'Africa/Dar_es_Salaam',
  AR: 'America/Argentina/Buenos_Aires', CL: 'America/Santiago',
  CO: 'America/Bogota', PE: 'America/Lima', VE: 'America/Caracas',
  EC: 'America/Guayaquil', UY: 'America/Montevideo',
  CR: 'America/Costa_Rica', PA: 'America/Panama',
  CU: 'America/Havana', JM: 'America/Jamaica',
  CN: 'Asia/Shanghai',
};

// US timezone estimation by longitude
function getUSTimezone(lon) {
  if (lon > -67.5) return 'America/New_York';       // Eastern
  if (lon > -82.5) return 'America/New_York';       // Eastern
  if (lon > -90) return 'America/Chicago';           // Central
  if (lon > -105) return 'America/Chicago';          // Central
  if (lon > -115) return 'America/Denver';           // Mountain
  if (lon > -125) return 'America/Los_Angeles';      // Pacific
  if (lon > -145) return 'America/Anchorage';        // Alaska
  return 'Pacific/Honolulu';                          // Hawaii
}

// Rough zone from longitude bands. Wrong near zone lines (Detroit comes out
// Central, Kazan Yekaterinburg), so it is used only if tz-lookup fails to load.
function guessTimezoneFromLongitude(countryCode, lon) {
  switch (countryCode) {
    case 'US': return getUSTimezone(lon);
    case 'CA':
      if (lon > -55) return 'America/St_Johns';
      if (lon > -65) return 'America/Halifax';
      if (lon > -80) return 'America/Toronto';
      if (lon > -97) return 'America/Winnipeg';
      if (lon > -110) return 'America/Edmonton';
      return 'America/Vancouver';
    case 'RU':
      if (lon < 40) return 'Europe/Moscow';
      if (lon < 55) return 'Asia/Yekaterinburg';
      if (lon < 90) return 'Asia/Novosibirsk';
      if (lon < 115) return 'Asia/Irkutsk';
      if (lon < 135) return 'Asia/Yakutsk';
      return 'Asia/Vladivostok';
    case 'AU':
      if (lon < 130) return 'Australia/Perth';
      if (lon < 142) return 'Australia/Adelaide';
      return 'Australia/Sydney';
    case 'BR':
      if (lon > -35) return 'America/Recife';
      if (lon > -50) return 'America/Sao_Paulo';
      if (lon > -55) return 'America/Cuiaba';
      return 'America/Manaus';
    case 'MX':
      if (lon > -90) return 'America/Cancun';
      if (lon > -105) return 'America/Mexico_City';
      return 'America/Tijuana';
    case 'ID':
      if (lon < 115) return 'Asia/Jakarta';
      if (lon < 135) return 'Asia/Makassar';
      return 'Asia/Jayapura';
    default:
      // Fallback: estimate from longitude
      const hoursFromGMT = Math.round(lon / 15);
      return `Etc/GMT${hoursFromGMT >= 0 ? '-' : '+'}${Math.abs(hoursFromGMT)}`;
  }
}

// tz-lookup carries a ~70 KB map of zone borders, so it loads with the first
// place search instead of with every page. Resolves to null if it cannot load.
let tzLookupLoad = null;
function loadTzLookup() {
  if (!tzLookupLoad) {
    tzLookupLoad = import('@photostructure/tz-lookup')
      .then((m) => m.default || m)
      .catch((err) => {
        console.warn('Could not load tz-lookup, guessing zones from longitude', err);
        tzLookupLoad = null;
        return null;
      });
  }
  return tzLookupLoad;
}

// The zone at the coordinates, or null when the lookup fails or this browser
// does not know the zone name (getUTCOffset would then silently use UTC)
function zoneAt(tzLookup, lat, lon) {
  try {
    const tz = tzLookup(lat, lon);
    new Intl.DateTimeFormat('en-CA', { timeZone: tz });
    return tz;
  } catch {
    return null;
  }
}

// Same rule as the compatibility-report lambda (resolvePerson in
// lambda-functions/ivy-compatibility-report/engine.js). Single-zone countries
// keep their exact zone: tz-lookup is approximate near borders and puts
// Vicovu de Sus, Romania, in Europe/Kyiv.
function getTimezoneForCountry(countryCode, lat, lon, tzLookup) {
  if (COUNTRY_TIMEZONE[countryCode]) return COUNTRY_TIMEZONE[countryCode];
  return (tzLookup && zoneAt(tzLookup, lat, lon)) || guessTimezoneFromLongitude(countryCode, lon);
}

// ---------------------------------------------------------------------------
// Geocoding via Nominatim (OpenStreetMap) - free, no API key
// ---------------------------------------------------------------------------

let geocodeAbortController = null;

/**
 * Search for cities using Nominatim geocoding API.
 * Returns array of { cityName, latitude, longitude, timezone, country }
 * Debounce and abort handling included.
 */
export async function geocodeCity(query) {
  if (!query || query.trim().length < 2) return [];

  // Abort any previous in-flight request
  if (geocodeAbortController) {
    geocodeAbortController.abort();
  }
  geocodeAbortController = new AbortController();
  const tzLookupReady = loadTzLookup(); // loads while Nominatim answers

  try {
    const url = `https://nominatim.openstreetmap.org/search?` +
      `q=${encodeURIComponent(query.trim())}` +
      `&format=json&addressdetails=1&limit=6` +
      `&featuretype=city`;

    const response = await fetch(url, {
      signal: geocodeAbortController.signal,
      headers: {
        'Accept-Language': 'en',
        'User-Agent': 'IvyAstrology/1.0',
      },
    });

    if (!response.ok) return [];

    const results = await response.json();
    const tzLookup = await tzLookupReady;

    return results
      .filter(r => r.lat && r.lon)
      .map(r => {
        const lat = parseFloat(r.lat);
        const lon = parseFloat(r.lon);
        const addr = r.address || {};
        const country = addr.country || '';
        const countryCode = (addr.country_code || '').toUpperCase();
        const city = addr.city || addr.town || addr.village || addr.municipality || addr.hamlet || r.name || query;
        const state = addr.state || '';
        const displayName = country
          ? `${city}${state ? ', ' + state : ''}, ${country}`
          : city;
        const timezone = getTimezoneForCountry(countryCode, lat, lon, tzLookup);

        return {
          cityName: displayName,
          latitude: lat,
          longitude: lon,
          timezone,
          country,
          countryCode,
        };
      });
  } catch (err) {
    if (err.name === 'AbortError') return []; // Expected on rapid typing
    console.warn('Geocoding failed:', err);
    return [];
  }
}
